/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//below js to update cart from cart page when user change dropdown.
let cartItems = [];

const getData = () => {
  axios.get('/cart.js')
    .then(response => {
        cartItems = response.data.items;
    })
    .catch(error =>{
      console.log('error', error)
    });
};

const updateData = (newVariant, oldVariant, quantity) => {

  let updates = {};
  quantity += getOldVariantQuantity(newVariant);
  updates[newVariant] = quantity;
  updates[oldVariant] = 0;
  axios.post('/cart/update.js',{updates})
    .then(response => {
      jQuery("form[action$='cart']").submit();
    })
    .catch(error =>{
      console.log('error', error)
    });
};

function getOldVariantQuantity(variant) {
  let revisedQuantity = 0;
  cartItems.forEach((elem) => {
    if ( variant == elem.id){
      revisedQuantity = elem.quantity;
    }
  });
  return revisedQuantity;
}

getData();

//swiper slider
var swiper = new Swiper('.swiper-container', {
  slidesPerView: 1,
  loop: true,
  setWrapperSize:true,
  centeredSlides: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


//select event listener
var select = document.querySelectorAll('.ProductItem__Info .product-option');
//javascript event listener
    select.forEach(function(el) {
    el.addEventListener('change', function() {
      var dataPrice = this.options[this.selectedIndex].getAttribute('data-price');
      var dataCompare = this.options[this.selectedIndex].getAttribute('data-sale');
      var dataID = this.options[this.selectedIndex].getAttribute('data-id');
      var button = document.querySelector('.ProductForm__AddToCart');
      var storeID = this.parentNode.querySelector('.id--identifier');
      if ( storeID ) {
        storeID.setAttribute('value', dataID);
      }
      if ( this.parentNode.parentNode.querySelector('.Price--highlight') ) {
        this.parentNode.parentNode.querySelector('.Price--highlight').innerText = dataPrice;
      }
      if ( this.parentNode.parentNode.querySelector('.Price--compareAt') ) {
        if ( dataCompare ) {
          this.parentNode.parentNode.querySelector('.Price--compareAt').style.display = '';
          this.parentNode.parentNode.querySelector('.Price--highlight').style.color = '';
          this.parentNode.parentNode.querySelector('.Price--compareAt').innerText = dataCompare;
        } else {
          this.parentNode.parentNode.querySelector('.Price--compareAt').style.display = 'none';
          this.parentNode.parentNode.querySelector('.Price--highlight').style.color = '#000';
        }
        
      }
      if (  this.parentNode.parentNode.querySelector('.Price--highlight') &&  this.parentNode.parentNode.querySelector('.Price--compareAt')) {

      } else {
        this.parentNode.parentNode.querySelector('.ProductItem__Price span').innerText = dataPrice;
      }
      
    });
});
